import { Typography } from '@volvo/vcdk-react';
import React from 'react';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';
import { cn } from '@/utils/cn';

type StepProps = {
  stepNo: number;
  label: string;
  status: 'completed' | 'current' | 'not-completed';
};

export const Step: React.FC<StepProps> = ({ stepNo, label, status }) => {
  return (
    <li className="flex flex-row items-center gap-4">
      <div
        className={cn(
          'border-gray flex size-8 items-center justify-center rounded-full border bg-white text-sm text-black',
          {
            'bg-black text-white': status === 'completed',
            'border-black bg-black text-white': status === 'current',
            '': status === 'not-completed',
          }
        )}
      >
        {status === 'completed' ? '✓' : stepNo}
      </div>
      <Typography variant="caption1" className="text-gray-dark">
        {label}
      </Typography>
      <hr className="border-subtle h-1 flex-1" />
    </li>
  );
};

type Props = {
  children?: React.ReactNode;
};

const Stepper: React.FC<Props> = ({ children }) => {
  return (
    <ol className="flex flex-row justify-between [&>li]:flex-1 [&>li:last-of-type]:flex-none [&>li:last-of-type>hr]:hidden">
      {children}
    </ol>
  );
};

export default withComponentErrorBoundary(Stepper);
